import blazy from "./components/blazy";
import infiniteScroll from "./components/infiniteScroll";
import filterAndSort from "./components/filterAndSort";
import scrollToTop from "./components/scrollToTop";
import newsletter from "./components/newsletter";
import socialShare from "./components/social-share";
import swiper from "./components/swiper";
import menu from "./components/menu";
import accordion from "./components/accordion";
import heroVideo from "./components/heroVideo";
import Foundation from 'foundation-sites';
import contactForm from "./components/contactForm";


blazy();
infiniteScroll();
filterAndSort();
scrollToTop();
newsletter();
socialShare();
swiper();
menu();
accordion();
heroVideo();
contactForm();

$(document).foundation();
